import { getPriceAdjustmentLabel, PriceAdjustment } from '../../../models/price-adjustments'
import { getPriceCurrencySymbol } from '../../../models/price-format'
import { widgetState } from '../../../store/customizations/index'
import { getSellingPlanGroup, getSellingPlanGroups } from '../../../store/selling-plans/getters'

export const groupsHasAnyDiscount = () => {
  return getSellingPlanGroups().some(group => group.sellingPlans.some(plan => {
    return plan.priceAdjustments.length && plan.priceAdjustments[0].value > 0
  }))
}
export const getDiscountLabel = (priceAdjustments: PriceAdjustment[], groupId: string): string => {
  const group = getSellingPlanGroup(groupId)
  if (group.sellingPlans) {
    const hasAtLeastOneDiscount = group.sellingPlans.some(plan => {
      return plan.priceAdjustments.length && plan.priceAdjustments[0].value > 0
    })
    if (!hasAtLeastOneDiscount) {
      return ''
    }
  }
  if (priceAdjustments) {
    const firstPriceAdjusment = priceAdjustments[0]
    if (firstPriceAdjusment && firstPriceAdjusment.value) {
      return formatLabelWithDiscount(firstPriceAdjusment)
    }
  }
  return formatLabelWithoutDiscount()
}

const formatLabelWithoutDiscount = () => {
  return `(${widgetState.customizations.tiles.fullPriceText})`
}

const formatLabelWithDiscount = (firstPriceAdjusment: PriceAdjustment) => {
  const currency = getPriceCurrencySymbol(widgetState.customizations.fullFormatProductPrice)
  const priceAdjustmentLabel = getPriceAdjustmentLabel(firstPriceAdjusment, currency)
  const labelSuffix = widgetState.customizations.tiles.suffixText
  return `(${priceAdjustmentLabel}${labelSuffix})`
}
